import {Pipe, PipeTransform} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {AppService} from '@api';
import {Config} from '../app.config';
import {SistemaService} from '@servicios/Sistema.Service';
import {Observable} from 'rxjs';

@Pipe(
    {
        name: 'Imagen'
    })

export class ImagenPipe implements PipeTransform {
    constructor(private http: HttpClient, private config: Config, private appService: AppService, private sistemaService: SistemaService) {
    }

    transform(url: string) {
        return new Observable<string>((observer) => {
            let headers = this.appService.SetHeader([]);            
            
            let httpOptions = {headers: headers, observe: 'response' as 'response', responseType: 'blob' as 'blob'};
            this.http.get(url, httpOptions).subscribe((response: HttpResponse<any>) => {
                const reader = new FileReader();
                reader.readAsDataURL(response.body);
                reader.onloadend = function () {
                    observer.next(reader.result as string);
                };
            })
        });
    }
}
